import React, { useMemo, useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useDispatch, useSelector } from 'react-redux';
import cN from 'classnames';
import { store } from '@Redux/search/store';
import { I_FilterItem, I_NormGroup } from '@Redux/search/interfaces';
import { setPageType } from '@Redux/common/Page/actions';
import { setTrigger } from '@Redux/search/actions';
import SearchPanelBlock from '@components/Common/SearchPanelBlock';
import SlidePage from '@components/Common/SlidePage';
import * as Icons from '@components/Common/Icons';
import TagFilters from '@components/SearchPage/TagFilters';
// import CruiseAd from '@components/SearchPage/CruiseAd';
import Conditions from '@components/SearchPage/Conditions';
import Sorters from '@components/SearchPage/Sorters';
import Filters from '@components/SearchPage/Filters';
import ResultCards from '@components/SearchPage/ResultCards';
import ResultList from '@components/SearchPage/ResultList';
import { createSearchPanel } from '@utils/creaeteSearchPanel';
import BreadCrumb from '@components/Common/BreadCrumb';
import domainbyEnv from '@utils/domainByEnv';
import { homeDomain } from '@utils/domainForCompany';
import '@magaele/ntb_lnsd';
import '@magaele/cd_gpsm';
import '@magaele/cd_gpsm/css.css';
import '@magaele/ntb_lnsd/css.css';
import '@magaele/ic-ln/css.css';
// import CruiseImg from './imgs/cruise.jpg';
import 'normalize.css';
import './styles.scss';
import i18n from '@utils/i18n';
import { RootState } from '@Redux/search/store';

declare global {
    interface Window {
        dataLayer: any;
    }
}
i18n();

const SearchPanelBlockM = () => {
    const [isOpenPanel, setIsOpenPanel] = useState<boolean>(false);
    const [defaultArrive, setDefaultArrive] = useState<string>('');

    useEffect(() => {
        createSearchPanel({ device: 'M', mCloseBtn: setIsOpenPanel });

        (async () => {
            const res = await fetch(
                `${domainbyEnv()}/_webassets/customsearchpaneldata/trs1newlightspeed.js`
            );
            const dataString = await res.text();
            const data = (() => {
                const newVariable = dataString
                    .replace(/\r?\n|\r/g, '')
                    .replace(/(?:var|let|const)\s(\w+)\s=/g, '"$1":')
                    .replace(/;/g, ',')
                    .replace(/,$/g, '')
                    .replace(/'/g, '"');
                return JSON.parse('{' + newVariable + '}');
            })();

            const urlParams = new URLSearchParams(window.location.search);
            const ArriveID = urlParams.get('ArriveID');
            const Keywords = urlParams.get('Keywords');

            if (Keywords) {
                setDefaultArrive(Keywords);
            } else if (ArriveID) {
                const ArriveArray = ArriveID?.split(',');
                ArriveArray?.pop();

                const ArriveString = ArriveArray?.reduce((accu: string[], arriveItem: string) => {
                    const tempItem = arriveItem.replace(/-/g, ',_');
                    const [vLinewebarea, vLinetravel, vLine] = tempItem.split(',');

                    let text: string;
                    if (vLinetravel === '_') {
                        text = data.vLine[vLine];
                    } else if (vLinewebarea === '') {
                        text = data.vLinetravel[vLine][`${vLinetravel}${vLine}`];
                    } else {
                        text = data.vLinewebarea[`${vLinetravel}${vLine}`][`_${vLinewebarea}`];
                    }

                    return [...accu, text];
                }, []);

                setDefaultArrive(ArriveString?.join('、')!);
            }
        })();
    }, []);

    const moduleName = 'searchPanel_block_m';

    return (
        <div className={moduleName}>
            <span
                className={cN(`${moduleName}_input`, { hasValue: defaultArrive })}
                onClick={() => setIsOpenPanel(true)}
            >
                {defaultArrive ? defaultArrive : '搜尋行程'}
            </span>
            <button className={`${moduleName}_button`} onClick={() => setIsOpenPanel(true)}>
                <Icons.Magnifier fill="#fff" />
            </button>
            <SlidePage
                visible={isOpenPanel}
                setIsVisible={setIsOpenPanel}
                title="團體旅遊"
                isHeaderShow={false}
            >
                <div id="SearchPanelM" />
            </SlidePage>
        </div>
    );
};

const Search = () => {
    const moduleClass = 'search';
    const [isFilterMOpen, setIsFilterMOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const GroupListData = useSelector(
        (store: RootState) => store.search.GroupListInfo.data || store.search.GroupListInfoM.data
    );
    const trigger: string = useSelector((store: RootState) => store.search.Trigger);

    useEffect(() => {
        dispatch(setPageType('search'));
    }, [dispatch]);
    const switchByOptions = useMemo(() => {
        return [
            {
                text: '切換行程顯示',
                value: 'List',
            },
            {
                text: '切換個團顯示',
                value: 'Cards',
            },
        ];
    }, []);

    const sortByOptions = useMemo(
        () => ({
            flatBtn: {
                text: '依出發日',
                value: 3,
            },
            dropdowns: [
                {
                    options: [
                        {
                            text: '依售價',
                            value: 0,
                        },
                        {
                            text: '依售價低到高',
                            value: 1,
                        },
                        {
                            text: '依售價高到低',
                            value: 2,
                        },
                    ],
                },
                {
                    options: [
                        {
                            text: '依天數',
                            value: 0,
                        },
                        {
                            text: '依天數低到高',
                            value: 4,
                        },
                        {
                            text: '依天數高到低',
                            value: 5,
                        },
                    ],
                },
            ],
        }),
        []
    );

    const countryLink = useCallback(() => {
        const taiwan = {
            href: `${homeDomain}/category/zh-tw/taiwan/index`,
            text: '台灣團體',
        };

        const foreign = {
            href: `${homeDomain}/category/zh-tw/travel/index`,
            text: '國外團體',
        };

        const urlParams = new URLSearchParams(window.location.search);
        const ArriveID = urlParams.get('ArriveID');
        const Keywords = urlParams.get('Keywords');
        const GroupID = urlParams.get('GroupID');

        if (Keywords || GroupID) return [taiwan, { ...foreign, spliter: '/' }];

        if (ArriveID && typeof ArriveID === 'string') {
            const ArriveIDArray = ArriveID?.split(',');
            const ArriveIDArrayLength =
                ArriveIDArray[ArriveIDArray.length - 1] !== ''
                    ? ArriveIDArray.length
                    : ArriveIDArray.length - 1;

            const taiwanAry = ArriveIDArray.filter(function (item) {
                return item.match(/-9$/g);
            });

            if (taiwanAry.length == ArriveIDArrayLength) {
                // 全部目的地都在台灣時
                return [taiwan];
            } else if (taiwanAry.length == 0) {
                // 沒目的地在台灣時
                return [foreign];
            } else {
                return [taiwan, { ...foreign, spliter: '/' }];
            }
        }

        return [taiwan, { ...foreign, spliter: '/' }];
    }, []);

    const routes = useMemo(() => {
        return [
            {
                href: homeDomain,
                text: '首頁',
            },
            ...countryLink(),
            {
                href: undefined,
                text: '搜尋結果頁',
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countryLink, homeDomain]);

    const calculateDiscount = (orig: string, sales: string) => {
        const origNum = parseInt(orig.replace(/,/g, ''));
        const salesNum = parseInt(sales.replace(/,/g, ''));
        return ((origNum - salesNum) / origNum) * 100;
    };

    //寫入ga4
    useEffect(() => {
        const ga4Arr: any = [];
        const getBreadCrumb = routes
            .flatMap((route) => {
                return route.text;
            })
            .join();
        if (GroupListData) {
            GroupListData.NormGroupList.forEach((groupItem: I_NormGroup, ind: number) => {
                const ga4Data = {
                    item_id: groupItem.GroupList[0].GroupID,
                    item_name: groupItem.TourName,
                    affiliation:
                        groupItem.TourBu === '旅天下'
                            ? 'Uplan Travel'
                            : groupItem.TourBu === '雄保'
                            ? 'Lionbobby'
                            : 'Lion Travel',
                    currency: 'TWD',
                    discount: groupItem.GroupIsVip
                        ? calculateDiscount(
                              groupItem.GroupVipOrigPrice,
                              groupItem.GroupStraightPrice
                          ).toFixed(2)
                        : 0,
                    index: ind + 1 + (GroupListData.CurrentPage - 1) * 10,
                    item_brand: 'Lion Travel',
                    item_category: getBreadCrumb.includes('國外') ? 'B2CWebpd' : 'B2CWebtwpd',
                    price: `${groupItem.GroupStraightPrice}`.split(',').join(''),
                };
                ga4Arr.push(ga4Data);
            });
            // 查看trigger裡面是否有這個Page
            const gate = trigger.includes(`,${GroupListData.CurrentPage}`);
            // 只有當頁面改變才會重新傳一筆ga4，並且記錄過去進入過的頁面
            if (!gate) {
                window.dataLayer = window.dataLayer || [];
                ga4Arr.length !== 0 &&
                    window.dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            items: ga4Arr,
                        },
                    });
                const newTrigger = trigger + ',' + GroupListData.CurrentPage;
                dispatch(setTrigger(newTrigger));
            }

            // 當傳過來沒有資料還是得推一個ga4
            if (GroupListData.NormGroupList.length === 0 && trigger === '') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'view_item_list',
                    ecommerce: {
                        items: [],
                    },
                });
                dispatch(setTrigger(','));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [GroupListData, trigger]);

    return (
        <div className={moduleClass}>
            <SearchPanelBlock routes={routes} />
            <div
                id="sidebar_nion"
                className="pge_conl"
                data-sidebar-position="0"
                data-sidebar-icon-favorite="false"
                data-sidebar-icon-history="false"
                data-sidebar-icon-compareb2c="false"
                data-sidebar-icon-copytrip="false"
                data-sidebar-icon-downloadtrip="false"
                data-sidebar-icon-printtrip="false"
                data-sidebar-icon-shares="true"
                data-sidebar-icon-b2b-forward="false"
                data-sidebar-icon-fb="true"
                data-sidebar-icon-line-pc="true"
                data-sidebar-icon-line-m="true"
                data-sidebar-icon-comparebbc="true"
            />

            <div className={`${moduleClass}_content`}>
                <BreadCrumb routes={routes} />
                <h3 className={`${moduleClass}_title`}> </h3>
                <SearchPanelBlockM />
                <TagFilters onConfirm={(finalItems: I_FilterItem[]) => {}} />
                <div className={`${moduleClass}_resultWrap`}>
                    <div className={`${moduleClass}_filtersWrap`}>
                        <Filters
                            isSlideOpen={isFilterMOpen}
                            setSlideOpen={setIsFilterMOpen}
                            onConfirm={(finalItems: I_FilterItem[]) => {}}
                        />
                    </div>
                    <div className={`${moduleClass}_result`}>
                        <div className={`${moduleClass}_conditions`}>
                            <Conditions whenClick={(items) => console.log('Conditions', items)} />
                            <Sorters
                                onClickFlatBtnM={() => setIsFilterMOpen(true)}
                                switchByOptions={switchByOptions}
                                sortByOptions={sortByOptions}
                            />
                        </div>
                        <ResultList />
                        <ResultCards />
                    </div>
                </div>
            </div>
        </div>
    );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <Search />
        </Provider>
    </React.StrictMode>
);

export default Search;
